module.exports = __webpack_public_path__ + "static/media/trekke_fra.f799cbc9.m4a";